import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './design-system';

import './styles/css-styles/index.scss';

export * from './components';
export * from './features';
export * from './translations';
export * from './services';
export * from './custom-hooks';

export * from './design-system';

export { message } from 'antd';

dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
